// src/pages/admin/users/components/useUserColumns.js
import React, { useMemo } from 'react';
import { Badge } from 'react-bootstrap';
import UserActionsCell from './UserActionsCell';

export const useUserColumns = ({ users, handleView, handleDelete, handleSuspend }) => {
    return useMemo(() => [
        { accessorKey: 'id', header: 'ID' },
        { accessorKey: 'full_name', header: 'Name' },
        { accessorKey: 'email', header: 'Email' },
        { accessorKey: 'mobile_no', header: 'Phone' },
        {
            accessorKey: 'is_verified',
            header: 'Verification Status',
            cell: info => (
                <Badge pill bg={info.getValue() ? 'success' : 'warning'}>
                    {info.getValue() ? 'Verified' : 'Pending Verification'}
                </Badge>
            )
        },
        {
            accessorKey: 'is_suspended',
            header: 'Account Status',
            cell: info => (
                <Badge pill bg={info.getValue() ? 'danger' : 'success'}>
                    {info.getValue() ? 'Suspended' : 'Active'}
                </Badge>
            )
        },
        {
            id: 'actions',
            header: () => <div style={{ textAlign: 'center', width: '100%' }}>ACTIONS</div>,
            enableSorting: false,
            cell: ({ row }) => (
                <UserActionsCell 
                    user={row.original} 
                    handleView={handleView} 
                    handleDelete={handleDelete} 
                    handleSuspend={handleSuspend} 
                />
            )
        }
    ], [users, handleView, handleDelete, handleSuspend]);
};
